import React from 'react';

// Calculate efficiency of custom path compared to auto path
const calculateEfficiency = (customDist, autoDist) => {
  if (!customDist || !autoDist) return { value: 0, better: false };
  
  const diff = customDist - autoDist;
  const percent = (diff / autoDist) * 100;
  
  return {
    value: Math.abs(percent),
    better: diff < 0
  };
};

const OptimizationSuggestions = ({ customSegments, autoSegments, isCustomBetter }) => {
  if (!customSegments || customSegments.length === 0) return null;
  
  // Generate segment-specific suggestions
  const segmentSuggestions = customSegments.map((segment, index) => {
    // Try to find corresponding auto path segment
    const matchingAutoSegment = autoSegments.find(
      auto => (auto.from.id === segment.from.id && auto.to.id === segment.to.id) ||
              (auto.from.id === segment.to.id && auto.to.id === segment.from.id)
    );
    
    if (matchingAutoSegment && segment.distance > matchingAutoSegment.distance * 1.1) {
      // If custom path segment is 10% longer than auto path, provide suggestion
      return (
        <li key={`suggestion-${index}`} className="suggestion-item">
          <span className="worse">Path segment {segment.from.name} → {segment.to.name}</span> 
          is 
          <span className="worse"> {((segment.distance / matchingAutoSegment.distance - 1) * 100).toFixed(1)}%</span>
          longer than algorithm path, suggest trying alternative route
        </li>
      );
    }
    return null;
  }).filter(Boolean);
  
  return (
    <div className="optimization-suggestions">
      <h6>Optimization Suggestions</h6>
      <ul className="suggestions-list">
        {segmentSuggestions.length > 0 ? segmentSuggestions : (
          <li>
            Path sequence may need optimization. Try adjusting the order of visiting points to reduce total distance.
          </li>
        )}
      </ul>
    </div>
  );
};

export default OptimizationSuggestions; 